
import { Card, Typography, Box} from "@mui/material"
import { cardStyle, icons, butttonWithIcon, secondary_icon } from "../../styles/sharedStyles";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import StraightenRoundedIcon from '@mui/icons-material/StraightenRounded';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';

export const UploadFileDetails = ({ columnCount, droppedColumnsData, rowCount, isEDAReportAvailable, downloadEDAReport, eda_report_msg  }) => {

    const headerStyle = { marginBottom: "4px", fontSize: "20px", fontWeight: "bold", fontFamily: "DM Sans, sans-serif", color: "#09224a" }

    const subHeaderStyle = { fontSize: "18px", fontWeight: "bold", fontFamily: "DM Sans, sans-serif", color: "#05265ae0", display: "flex", alignContent: "center" }
    const icon = { marginRight: "10px", fontSize: "28px"}
    const textStyle = { color: "#6c6c6c", marginLeft: "5px" }


    return (
        <>


            <Box display={"flex"}  alignItems={"center"} width={"100%"}><Typography variant="h6" component="h2" id="modal-modal-title" sx={[headerStyle, {color: "#4cbe00ff"}]}>Data processing completed </Typography>
            {eda_report_msg ?  <span style={{ display: "flex", alignItems: "center", marginLeft:"10px"}}>{eda_report_msg} </span> : null}
            {isEDAReportAvailable ? <span style={{ display: "flex", alignItems: "center", marginLeft:"10px"}}>EDA report generated
                            <Box sx={[butttonWithIcon, {
                                backgroundColor: "#dbdddb75",

                                "&:hover": {
                                    backgroundColor: "#babdba75",
                                }
                            }]}><DownloadForOfflineIcon sx={[secondary_icon, { color: "#47a00a" }]} onClick={downloadEDAReport} />
                            </Box>
                        </span> : null}</Box>
            <Card sx={cardStyle}>
                {droppedColumnsData && droppedColumnsData[0] == "No constant columns found" ? <Typography sx={subHeaderStyle}><StraightenRoundedIcon sx={[icon, {color: "#008cff" }]} /> Number of columns dropped: <span style={textStyle}> 0</span></Typography> :
                <Typography sx={subHeaderStyle}><StraightenRoundedIcon sx={[icon, {color: "#008cff" }]} /> Number of columns dropped: <span style={textStyle}> {columnCount}</span></Typography>}
                
                {droppedColumnsData && droppedColumnsData[0] != "No constant columns found" ? <Typography sx={[subHeaderStyle, {mt: 2}]}><DescriptionOutlinedIcon sx={[icon, {color: "darkorange" }]} />Dropped columns: </Typography> : null}

                <Typography sx={{ mt: 1, marginLeft: "3rem", fontFamily: "DM Sans, sans-serif", color: "#6c6c6c" }}>
                    {droppedColumnsData.map((item, index) => {
                        return (<span key={index} style={{ margin: "2px", fontSize: "18px" }}>{item}, </span>)

                    })}
                </Typography>

                <Typography sx={[subHeaderStyle, {mt: 2}]}><StraightenRoundedIcon sx={[icon, {color: "blueviolet" }]} /> Number of duplicate rows dropped: <span style={textStyle}> {rowCount}</span></Typography>


            </Card>





        </>
    )
}